import { createContext, useState, useEffect } from "react";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(() => {
    const localAuth = localStorage.getItem('user');
    return localAuth ? JSON.parse(localAuth) : null;
  });

  const [selectedBranches, setSelectedBranches] = useState(() => {
    const branches = localStorage.getItem('selectedBranches');
    return branches ? JSON.parse(branches) : [];
  });

  const [selectedWarehouses, setSelectedWarehouses] = useState(() => {
    const warehouses = localStorage.getItem('selectedWarehouses');
    return warehouses ? JSON.parse(warehouses) : [];
  });

  const setBranches = (branchIds) => {
    localStorage.setItem("selectedBranches",JSON.stringify(branchIds));
    setSelectedBranches(branchIds);
  };

  const setWarehouses = (warehouseIds) => {
    localStorage.setItem('selectedWarehouses', JSON.stringify(warehouseIds));
    setSelectedWarehouses(warehouseIds);
  }


  useEffect(() => {
    const channel = new BroadcastChannel('auth-channel');

    channel.onmessage = (e) => {
      if (e.data.type === 'AUTH_REFRESHED') {
        const { user } = e.data;
        const { associatedBranches=[], associatedWarehouses=[] } = user;

        setSelectedBranches(prevSelected=>{
          const branchIds=prevSelected.filter(branchId=>associatedBranches.includes(branchId));
          localStorage.setItem('selectedBranches',JSON.stringify(branchIds));
          return branchIds;
        })
        setSelectedWarehouses(prevSelected=>{
          const warehouseIds=prevSelected.filter(warehouseId=>associatedWarehouses.includes(warehouseId));
          localStorage.setItem('selectedWarehouses',JSON.stringify(warehouseIds));
          return warehouseIds;
        })
        localStorage.setItem('user', JSON.stringify(user));
        setAuth(user); 
      }
      if (e.data.type === 'LOGOUT') {
        localStorage.clear();
        setAuth(null); 
        setSelectedBranches([]);
        setSelectedWarehouses([]);
      }
    };

    return () => channel.close();
  }, []);

  return (
    <AuthContext.Provider
      value={{
        auth,
        setAuth,
        selectedBranches,
        setBranches,
        selectedWarehouses,
        setWarehouses,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export default AuthContext;